import getPublishedStateHeader from '../../helpers/getPublishedStateHeader';

export const SUCCESS = 'AUDIENCE_HEADER_SUCCESS';
export const FAILURE = 'AUDIENCE_HEADER_FAILURE';

const initialState = {
  loaded: false,
};

export default function audienceHeaderReducer(state = initialState, action) {
  switch (action.type) {
    case SUCCESS:
      return Object.assign(
        {},
        {
          loaded: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    case FAILURE:
      return Object.assign(
        {},
        {
          error: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    default:
      return state;
  }
}

export function fetchAudienceHeaderSuccess(data) {
  return { type: SUCCESS, data };
}

export function fetchAudienceHeaderFailure(data) {
  return { type: FAILURE, data };
}

export function fetchAudienceHeaderAction(audienceId) {
  return function (dispatch, getState, { Api, i18n }) {
    const {
      pageConfig: { previewMode, siteId },
    } = getState();

    return Api()
      .service('ContentService')
      .version('v1')
      .setup({
        headers: {
          'Accept-Language': i18n.language,
          'Published-State': getPublishedStateHeader(previewMode),
        },
      })
      .fetchAudienceHeader({ siteId: audienceId || siteId })
      .then((response) => {
        if (response.statusCode === 200) {
          return dispatch(fetchAudienceHeaderSuccess(response));
        } else {
          return dispatch(fetchAudienceHeaderFailure(response));
        }
      });
  };
}
